/**
 * The WhatsApp / E-Mail / Telefon button row. design.md 5.16, 8.1.4.
 *
 * Labels and hrefs are the source's own; only the glyph is added, matched to
 * the button's protocol rather than to its label, so the copy is never read.
 */
import type { ButtonBlockData } from '@/lib/content';
import SmartLink from './SmartLink';
import { MailIcon, PhoneIcon, WhatsAppIcon } from './Icons';

function glyphFor(url: string | null) {
  if (!url) return null;
  if (/^mailto:/i.test(url)) return <MailIcon />;
  if (/^tel:/i.test(url)) return <PhoneIcon />;
  if (/wa\.me|whatsapp/i.test(url)) return <WhatsAppIcon />;
  return null;
}

export default function ContactActions({
  buttons,
  className = 'hp-actions',
}: {
  buttons: ButtonBlockData[];
  className?: string;
}) {
  if (!buttons.length) return null;
  return (
    <div className={className}>
      {buttons.map((block, index) => {
        const primary = index === 0;
        const style = primary ? 'primary' : 'secondary';
        const glyph = glyphFor(block.url);
        return (
          <SmartLink
            to={block.url}
            className={`hp-button hp-button--${style}`}
            key={`${block.text}-${index}`}
          >
            {glyph}
            <span>{block.text}</span>
          </SmartLink>
        );
      })}
    </div>
  );
}
